var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsUUIDWithLVS, TransformWithLVS } from '@goparrot/common';
import { IsEmailOrPhone } from '@goparrot/notifier-sdk';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger-v4';
import { Expose } from 'class-transformer';
import { IsEmail, IsOptional, IsString } from 'class-validator';
import { CampaignExposeGroup } from '../interface';
export class ReadCampaignSenderDetailsDto {
}
__decorate([
    ApiProperty({ description: 'Notifier configuration uuid', example: '9eaa1d82-0b48-452e-baec-a00361937d67', type: () => String }),
    Expose({
        groups: [CampaignExposeGroup.MODEL, CampaignExposeGroup.READ, CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START],
    }),
    IsUUIDWithLVS(4, { groups: [CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE] }),
    __metadata("design:type", String)
], ReadCampaignSenderDetailsDto.prototype, "configurationUuid", void 0);
__decorate([
    ApiPropertyOptional({ description: 'Sender name', example: 'GoParrot', type: () => String }),
    Expose({
        groups: [CampaignExposeGroup.MODEL, CampaignExposeGroup.READ, CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START],
    }),
    IsString({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], ReadCampaignSenderDetailsDto.prototype, "senderName", void 0);
__decorate([
    ApiPropertyOptional({ description: 'From email/phone same as in notifier configuration', example: 'test@goparrot.ai', type: () => String }),
    Expose({
        groups: [CampaignExposeGroup.MODEL, CampaignExposeGroup.READ, CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START],
    }),
    IsString({ always: true, message: `"From" field is required.` }),
    TransformWithLVS(({ value }) => {
        if (!!value && typeof value === 'string' && value === value.replace(/\D/, '')) {
            value = `+${value}`;
        }
        return value;
    }),
    IsEmailOrPhone({ always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], ReadCampaignSenderDetailsDto.prototype, "from", void 0);
__decorate([
    ApiPropertyOptional({ description: 'Reply email same as in notifier configuration', example: 'no-reply@goparrot.ai', type: () => String }),
    Expose({
        groups: [CampaignExposeGroup.MODEL, CampaignExposeGroup.READ, CampaignExposeGroup.CREATE, CampaignExposeGroup.UPDATE, CampaignExposeGroup.START],
    }),
    IsString({ always: true }),
    IsEmail({}, { always: true }),
    IsOptional({ always: true }),
    __metadata("design:type", String)
], ReadCampaignSenderDetailsDto.prototype, "replyTo", void 0);
//# sourceMappingURL=ReadCampaignSenderDetailsDto.js.map